module.exports = __webpack_public_path__ + "static/media/household.22f52a71.png";